'use es6';

import { Record } from 'immutable';
export const HAS_NO_CONTACTS_TIER = -1; // The endpoint does not return contacts for free portals, friends-and-family, dev,
// or other cases where they aren't paying for a marketing contacts tier. This should
// be set appropriately so that we won't show warnings for these portals, but is a separate
// variable which can be adjusted for testing purposes.

const DEFAULT_CONTACTS_TIER = HAS_NO_CONTACTS_TIER;

class MarketingContactsInfo extends Record({
  contactsTier: null,
  countRealtime: null
}) {
  constructor({
    contactsTier,
    countRealtime
  } = {}) {
    super({
      contactsTier: contactsTier || DEFAULT_CONTACTS_TIER,
      countRealtime
    });
  }

}

export default MarketingContactsInfo;